import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { MenuService } from "./menu.service";
import { Observable, Observer } from "rxjs";
@Injectable()
export class MenuResolve implements Resolve<any> {
	constructor(private menuService: MenuService) {}

	resolve(): Observable<any> {
		return Observable.create((observer: Observer<any>) => {
			// We create an Observable here. But you could also make a
			// HTTP Request here with the Http Service
			// of the @angular/http module.
			var result$ = this.menuService.getApplicationItems();
			result$.subscribe(
				(response) => {
					observer.next(response);
					observer.complete();
				},
				(error) => {
					observer.error(error);
					observer.complete();
				}
			);
		});
	}
}
